<template>
  <v-hover v-slot="{ isHovering, props }">
    <span
      ref="button"
      v-bind="props"
      class="d-flex align-center cursor-pointer font-weight-transition font-weight-regular text-body-1"
      :class="{ 'font-weight-medium': isHovering || active }"
    >
      <button
        ref="text"
        v-bind="$attrs"
        class="bg-transparent border-0"
        :aria-label="isAsc ? $t('sortbyAsc', [label]) : $t('sortByDesc', [label])"
      >
        <span>{{ label }}</span>
        <v-icon v-if="isAsc" ref="icon-asc" :icon="mdiMenuUp" />
        <v-icon v-else ref="icon-desc" :icon="mdiMenuDown" />
      </button>
    </span>
  </v-hover>
</template>

<script setup lang="ts">
import { SortDirection } from '@/modules/order/types'
import { mdiMenuDown, mdiMenuUp } from '@mdi/js'
import { computed, PropType } from 'vue'

const componentProps = defineProps({
  label: {
    type: String,
    required: true
  },
  sort: {
    type: Number as PropType<SortDirection>,
    required: true
  },
  active: {
    type: Boolean,
    default: false
  }
})

const isAsc = computed(() => componentProps.sort === SortDirection.ASC)
</script>

<style lang="scss" scoped>
.font-weight-transition {
  transition: font-weight 0.05s ease-out;
}
</style>
